<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicList"
                caption="Liste des étampes"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/binder-pdf-stamp/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/binder-pdf-stamp"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'étampe')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette étampe?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'BinderPDFStampList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Titre'),
                        key: 'title',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de création'),
                        key: 'creationDate',
                        type: 'date',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                this.$router.push('etampes/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicList.retrieve()
            },
            retrieve() {
                this.$refs.dynamicList.retrieve()
            }
        }
    }
</script>
